import { PermissionMapping } from '@@/lib/permissions';

export type AccessManagementPermission = 'reader' | 'writer' | 'business-user';

export const accessManagementPermissionMapping: PermissionMapping<AccessManagementPermission>[] = [
  {
    permissionSetMapping: {
      reader: ['access-management-admin', 'access-management-viewer'],
      writer: ['access-management-admin']
    },
    urlSignature: '/roles',
    showInNavbar: true,
    label: 'Roles'
  },
  {
    permissionSetMapping: {
      reader: ['access-management-viewer', 'access-management-admin'],
      writer: ['access-management-admin']
    },
    urlSignature: '/permissions',
    showInNavbar: true,
    label: 'Permissions'
  },
  {
    permissionSetMapping: {
      reader: ['access-management-viewer', 'access-management-admin'],
      writer: ['access-management-admin']
    },
    urlSignature: '/users',
    showInNavbar: true,
    label: 'Users'
  },
  {
    permissionSetMapping: {
      reader: ['access-management-viewer', 'access-management-admin'],
      writer: ['access-management-admin']
    },
    urlSignature: '/users/*',
    showInNavbar: true,
    label: 'Users'
  }
];

export default accessManagementPermissionMapping;
